var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"app-menu__link-item",attrs:{"href":"#","title":"Шлагбаумы"},on:{"click":function($event){$event.preventDefault();return _vm.openPage()}}},[_c('span',{staticClass:"menu-icon"},[_c('icon',{attrs:{"name":"app-barrier"}})],1),_c('span',{staticClass:"app-menu__link-item-title"},[_vm._v("Шлагбаумы")])])
}
var staticRenderFns = []

export { render, staticRenderFns }